import { render, staticRenderFns } from "./NewResearchOutputClaim.vue?vue&type=template&id=68498d74&scoped=true&"
import script from "./NewResearchOutputClaim.vue?vue&type=script&lang=js&"
export * from "./NewResearchOutputClaim.vue?vue&type=script&lang=js&"
import style0 from "./NewResearchOutputClaim.vue?vue&type=style&index=0&id=68498d74&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68498d74",
  null
  
)

export default component.exports